/* ==========================================================================
   hp-page-warranty-coverage.js - brand search for the warranty coverage band
   (sections/hp-page-warranty-coverage.liquid). Client-side only, no network:
   on input it highlights the matching brand names in both route lists
   ([data-warranty-brand-row][data-brand]) and writes a result line
   ([data-warranty-brand-result], aria-live) from the three templates on the
   section root (data-result-iac / -manufacturer / -none, "{brand}" token).
   An empty field restores the lists. Successor of initBrandSearch in
   assets/warranty-page.js (not loaded here). ES5, defer-safe, idempotent.
   ========================================================================== */
(function (win, doc) {
  'use strict';

  function fill(template, brand) {
    return String(template || '').replace(/\{brand\}/g, brand);
  }

  function init(root) {
    if (!root || root.getAttribute('data-hp-bound') === 'true') { return; }
    var input = root.querySelector('[data-warranty-brand-search]');
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-warranty-brand-row]'));
    var result = root.querySelector('[data-warranty-brand-result]');
    if (!input || !rows.length) { return; }
    root.setAttribute('data-hp-bound', 'true');

    var templates = {
      iac: root.getAttribute('data-result-iac') || '',
      manufacturer: root.getAttribute('data-result-manufacturer') || '',
      none: root.getAttribute('data-result-none') || ''
    };

    function setResult(text, kind) {
      if (!result) { return; }
      result.classList.remove('is-iac', 'is-manufacturer', 'is-none');
      if (!text) {
        result.hidden = true;
        result.textContent = '';
        return;
      }
      result.textContent = text;
      result.classList.add('is-' + kind);
      result.hidden = false;
    }

    function render() {
      var q = (input.value || '').trim().toLowerCase();
      var best = null;
      var exact = null;

      rows.forEach(function (row) {
        var name = (row.getAttribute('data-brand') || '').trim();
        var lower = name.toLowerCase();
        var match = !!q && lower.indexOf(q) !== -1;
        row.classList.toggle('is-match', match);
        row.classList.toggle('is-dim', !!q && !match);
        if (match) {
          if (!best) { best = row; }
          if (!exact && lower === q) { exact = row; }
        }
      });

      if (!q) {
        setResult('', '');
        return;
      }
      var pick = exact || best;
      if (!pick) {
        setResult(templates.none, 'none');
        return;
      }
      var type = pick.getAttribute('data-warranty-type') === 'manufacturer' ? 'manufacturer' : 'iac';
      var text = fill(templates[type], pick.getAttribute('data-brand') || '');
      setResult(text, type);
    }

    input.addEventListener('input', render);
    input.addEventListener('search', render);   /* native clear on type=search */
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        if (input.value) {
          input.value = '';
          render();
          e.preventDefault();
        }
      }
    });
    if (input.value) { render(); }
  }

  function boot(scope) {
    var ctx = scope && scope.querySelectorAll ? scope : doc;
    Array.prototype.forEach.call(ctx.querySelectorAll('.hp-page-warranty-coverage'), init);
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', function () { boot(doc); });
  } else {
    boot(doc);
  }
  doc.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})(window, document);
